export default __webpack_public_path__ + "static/media/gw12.6bbf9a38.webp";